import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/DiamondsMaster.css";

function DiamondsMaster() {
  const [size, setSize] = useState("");
  const [color, setColor] = useState("WHITE");
  const [diamonds, setDiamonds] = useState([]);

  const fetchDiamonds = async () => {
    const { data, error } = await supabase
      .from("DIAMONDS")
      .select("*")
      .order("size", { ascending: true });

    if (!error) setDiamonds(data);
  };

  const addDiamond = async () => {
    if (!size.trim()) {
      alert("Please enter a diamond size");
      return;
    }

    const { error } = await supabase.from("DIAMONDS").insert([{ size, color }]);
    if (error) {
      alert("Error adding diamond");
    } else {
      setSize("");
      setColor("WHITE");
      fetchDiamonds();
    }
  };

  const deleteDiamond = async (id) => {
    if (!window.confirm("Delete this diamond?")) return;

    const { error } = await supabase.from("DIAMONDS").delete().eq("id", id);
    if (!error) fetchDiamonds();
  };

  useEffect(() => {
    fetchDiamonds();
  }, []);

  return (
    <div className="diamond-page">

      <h2 className="page-title">
        💎 Diamonds Master
      </h2>

      {/* Add Diamond Box */}
      <div className="diamond-card">

        <div className="diamond-card-title">
          ➕ Add Diamond
        </div>

        {/* Input Row */}
        <div className="input-row">
          <div className="input-group">
            <label>Diamond Size:</label>
            <input
              type="text"
              value={size}
              onChange={(e) => setSize(e.target.value)}
              placeholder="e.g. 1.20"
            />
          </div>

          <div className="input-group">
            <label>Diamond Color:</label>
            <select value={color} onChange={(e) => setColor(e.target.value)}>
              <option value="WHITE">WHITE</option>
              <option value="YELLOW">YELLOW</option>
              <option value="BLACK">BLACK</option>
            </select>
          </div>
        </div>

        <button className="main-btn" onClick={addDiamond}>
          Add Diamond
        </button>
      </div>

      {/* Table */}
      <table className="diamond-table">
        <thead>
          <tr>
            <th>Size</th>
            <th>Color</th>
            <th style={{ width: "160px" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {diamonds.length === 0 ? (
            <tr>
              <td colSpan="3" className="no-records">No Records Found</td>
            </tr>
          ) : (
            diamonds.map((d) => (
              <tr key={d.id}>
                <td>{d.size}</td>
                <td>{d.color}</td>
                <td>
  <div className="action-buttons">
    <button className="edit-btn">Edit</button>
    <button className="delete-btn" onClick={() => deleteDiamond(d.id)}>Delete</button>
  </div>
</td>

              </tr>
            ))
          )}
        </tbody>
      </table>

    </div>
  );
}

export default DiamondsMaster;
